import { z } from "zod/v4"

/**
 * API Key Scope schema
 */
export const apiKeyScopeSchema = z.union([
  z.literal("read:people"),
  z.literal("write:people"),
  z.literal("read:finance"),
  z.literal("write:finance"),
])

export type TApiKeyScope = z.infer<typeof apiKeyScopeSchema>

/**
 * API Key schema based on backend response
 */
export const apiKeySchema = z.object({
  id: z.string(),
  name: z.string(),
  keyPrefix: z.string(),
  scopes: z.array(apiKeyScopeSchema),
  createdAt: z.string().datetime(),
  lastUsedAt: z.string().datetime().nullable(),
  expiresAt: z.string().datetime().nullable(),
  isActive: z.boolean(),
})

export type TApiKey = z.infer<typeof apiKeySchema>

/**
 * Create API Key request schema
 */
export const createApiKeyRequestSchema = z.object({
  name: z.string().min(1, "Name is required"),
  scopes: z.array(apiKeyScopeSchema).min(1, "At least one scope is required"),
  expiresAt: z.string().datetime().nullable().optional(),
})

export type TCreateApiKeyRequest = z.infer<typeof createApiKeyRequestSchema>

/**
 * Create API Key response schema
 * Note: The full key is only returned once at creation
 */
export const createApiKeyResponseSchema = apiKeySchema.and(
  z.object({
    apiKey: z.string(),
  }),
)

export type TCreateApiKeyResponse = z.infer<typeof createApiKeyResponseSchema>

/**
 * List API Keys response schema
 */
export const listApiKeysResponseSchema = z.object({
  apiKeys: z.array(apiKeySchema),
})

export type TListApiKeysResponse = z.infer<typeof listApiKeysResponseSchema>

/**
 * Revoke API Key response schema
 */
export const revokeApiKeyResponseSchema = z.object({
  message: z.string(),
})

export type TRevokeApiKeyResponse = z.infer<typeof revokeApiKeyResponseSchema>
